(() => {
  const KEY = 'elmsett.shopping-help.v1', DRAFT = 'elmsett.contact-draft.v1', PENDING = 'elmsett.cart-check.v1';
  const ttl = 30 * 60 * 1000;
  const clean = (value, max = 400) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, max);
  const read = key => { try { const value = JSON.parse(sessionStorage.getItem(key)); return value && (key === PENDING || Date.now() - value.at < ttl) ? value : null; } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify({...value, at: Date.now()})); } catch {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  const root = () => window.routes?.root_url || window.Shopify?.routes?.root || '/';
  const cartPath = () => window.routes?.cart_url || root() + 'cart';
  function themePath(path) {
    const url=new URL(path,location.origin);
    const preview=new URLSearchParams(location.search).get('preview_theme_id') || (window.Shopify?.theme?.role==='unpublished'?String(window.Shopify.theme.id):'');
    if (/^\d+$/.test(preview || '')) url.searchParams.set('preview_theme_id',preview);
    return url.pathname+url.search;
  }
  const cartHref=()=>themePath(cartPath());
  function safePath(value) {
    try { const url = new URL(value, location.origin); if (url.origin !== location.origin) return root() + 'collections/all';
      const path = url.pathname; return /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:products\/[^/]+|collections(?:\/[^/]+)?|cart|)$/.test(path) ? path : root() + 'collections/all';
    } catch { return root() + 'collections/all'; }
  }
  function context(link) {
    const form = link.closest('product-form');
    const page = safePath(location.pathname);
    const product = form?.dataset.helpProduct || '';
    const variantId = form?.querySelector('[name=id]')?.value || '';
    const productInfo = form?.closest('product-info') || document.querySelector('main');
    const variant = form ? [...(productInfo?.querySelectorAll('variant-selects input:checked, variant-selects option:checked') || [])].map(x => x.value).join(' / ') : '';
    const scope = link.closest('cart-drawer') || link.closest('main') || link.closest('cart-items') || document;
    const errorNode = form?.querySelector('.product-form__error-message') || link.closest('.cart-item')?.querySelector('.cart-item__error-text') || scope.querySelector('#CartDrawer-CartErrors, #cart-errors');
    const error = errorNode ? [...errorNode.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join(' ') : '';
    const lines = form ? '' : [...scope.querySelectorAll('.cart-item')].slice(0, 10).map(row => clean(row.querySelector('.cart-item__name')?.textContent, 100) + ' — ' + clean([...row.querySelectorAll('dl .product-option')].map(option=>option.textContent).join(' / '),160) + ' × ' + clean(row.querySelector('input[name="updates[]"]')?.value,4)).join('; ');
    return {page, product:clean(product,120), variant:clean(variant,160), variantId:/^\d+$/.test(variantId)?variantId:'', module:form?'Add to cart':'Shopping cart', error:clean(error,600), items:clean(lines,1200)};
  }
  function initContact() {
    document.querySelectorAll('.es-contact__form').forEach(form => {
      if (form.dataset.helpReady) return;
      form.dataset.helpReady = 'true';
      const success = form.querySelector('[data-contact-success]');
      const saved = read(DRAFT);
      const requested = new URLSearchParams(location.search).get('help') === 'shopping' || (saved?.flow === 'shopping' && !!form.querySelector('.es-contact__error, [data-contact-success]'));
      const previous = read(KEY);
      const ctx = requested ? previous || {page:root()+'collections/all',module:'Shopping',error:''} : null;
      const continueLink = form.querySelector('[data-help-return]');
      if (continueLink && ctx) continueLink.href = safePath(ctx.page);
      if (continueLink && ctx && /^\d+$/.test(previous?.variantId || '') && /\/products\//.test(continueLink.pathname)) continueLink.href = safePath(previous.page) + '?variant=' + encodeURIComponent(previous.variantId);
      if (success) { remove(DRAFT); remove(KEY); return; }
      const message = form.querySelector('[name="contact[body]"]'), topic = form.querySelector('[data-contact-topic]');
      if (ctx) {
        topic.value = 'Website help';
        form.querySelector('[data-contact-topic-field]')?.setAttribute('hidden','');
        form.querySelector('[data-contact-order]')?.setAttribute('hidden','');
        form.querySelector('[data-contact-order] input')?.setAttribute('disabled','');
        form.classList.add('es-contact__form--help');
        if (!message.value.trim()) message.value = ctx.error ? 'I need help with ' + (ctx.product || 'my shopping cart') + '.\n\n' + ctx.error : '';
        for (const [label,key] of [['Page','page'],['Product','product'],['Variant','variant'],['Variant ID','variantId'],['Module','module'],['Error','error'],['Cart items','items']]) {
          const input=document.createElement('input');input.type='hidden';input.name='contact['+label+']';input.value=key==='page'?safePath(ctx.page):clean(ctx[key],key==='items'?1200:600);form.append(input);
        }
        form.action = new URL(form.getAttribute('action'),location.origin).pathname + '?help=shopping#' + form.id;
      }
      const flow=ctx?'shopping':'contact';
      if(saved?.flow===flow && !form.querySelector('.es-contact__error')) {
        for(const field of form.querySelectorAll('input:not([type=hidden]):not([disabled]), textarea, select')) if(field.name && saved.fields[field.name]!==undefined) field.value=saved.fields[field.name];
        if(ctx) topic.value='Website help';
      }
      topic?.dispatchEvent(new Event('change'));
      message?.dispatchEvent(new Event('input'));
      const save=()=> {const fields={};for(const field of form.querySelectorAll('input:not([type=hidden]):not([disabled]), textarea, select')) if(field.name?.startsWith('contact['))fields[field.name]=field.value.slice(0,5000);write(DRAFT,{flow,fields});};
      form.addEventListener('input',save);form.addEventListener('change',save);form.addEventListener('submit',save);
      const back=form.querySelector('[data-help-return]');if(back && ctx) back.href=safePath(ctx.page)+(/^\d+$/.test(ctx.variantId || '') && /\/products\//.test(ctx.page)?'?variant='+encodeURIComponent(ctx.variantId):'');
    });
  }
  function lockCheckout() {
    document.querySelectorAll('[name="checkout"]').forEach(button => {
      if (!button.disabled) button.dataset.helpLocked='true';
      button.disabled=true;
      const parent=button.closest('.cart__ctas') || button.parentElement;
      if(!parent.parentElement.querySelector('[data-help-review]')) {
        const notice=document.createElement('p');notice.className='es-cart-recovery';notice.dataset.helpReview='';notice.setAttribute('role','status');
        const message=document.createElement('span');message.textContent='Your cart couldn’t be updated.';
        const link=document.createElement('a');link.href=cartHref();link.textContent='Refresh cart';link.dataset.helpRefresh='';
        notice.append(message,link);parent.before(notice);
      }
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(element=>{if(!element.hidden)element.dataset.helpLocked='true';element.hidden=true;});
  }
  function confirmCart() {
    remove(PENDING);
    document.querySelectorAll('[name="checkout"][data-help-locked]').forEach(button=>{button.disabled=false;delete button.dataset.helpLocked;});
    document.querySelectorAll('.cart__dynamic-checkout-buttons[data-help-locked]').forEach(element=>{element.hidden=false;delete element.dataset.helpLocked;});
    document.querySelectorAll('[data-help-review]').forEach(element=>element.remove());
    document.querySelectorAll('product-form[data-help-uncertain]').forEach(form=>{
      delete form.dataset.helpUncertain;
      const button=form.querySelector('[type="submit"][data-help-locked]');if(button){button.disabled=false;delete button.dataset.helpLocked;}
      const link=form.querySelector('[data-help-check-bag]');if(link)link.textContent='View cart';
    });
  }
  // Only a fresh server-rendered cart confirms quantities; a cached page does not.
  let freshDocument = true;
  function init(event) {
    const freshCart = freshDocument && !event?.persisted && document.querySelector('cart-items') && /\/cart\/?$/.test(location.pathname);
    if (freshCart) confirmCart();
    if (freshCart || document.readyState !== 'loading') freshDocument = false;
    if (!read(PENDING)) confirmCart();
    if(read(PENDING)) lockCheckout();
    initContact();
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-shopping-help]');if(!link)return;
    const next=context(link), previous=read(KEY);
    if (!previous || ['page','product','variantId','error'].some(key => next[key] !== previous[key])) remove(DRAFT);
    write(KEY,next);
    // Keep normal link semantics; the native cart cookie is never modified.
  });
  document.addEventListener('submit',event=>{
    const form=event.target.closest('product-form');if(!form)return;
    const pending=read(PENDING),id=form.querySelector('[name=id]')?.value;
    if(pending?.variantId===id){event.preventDefault();event.stopImmediatePropagation();location.assign(cartHref());}
  },true);
  window.ElmsettHelp = {
    requireCartReview() { write(PENDING,{cart:true});lockCheckout(); },
    confirmCart,
    cartHref,
    sectionContext:()=>themePath(location.pathname),
    async uncertain(form, reason) {
      const id=form.querySelector('[name=id]')?.value || '';
      write(PENDING,{variantId:id});lockCheckout();
      form.dataset.helpUncertain='true';
      if (!form.submitButton.disabled) form.submitButton.dataset.helpLocked='true';
      form.submitButton.disabled=true;
      const cartLink=form.querySelector('[data-help-check-bag]');
      if(cartLink){cartLink.hidden=false;cartLink.href=cartHref();cartLink.textContent='Refresh cart';}
      let message = clean(reason,400) || 'We couldn’t confirm whether this rug was added.';

      form.handleErrorMessage(message);
      try {
        const response=await fetch(cartPath()+'.js',{headers:{Accept:'application/json'},cache:'no-store',signal:AbortSignal.timeout(8000)});
        if(!response.ok)throw Error('Cart unavailable');
        const cart=await response.json();if(!Array.isArray(cart.items))throw Error('Cart unavailable');
        const quantity=cart.items.filter(item=>String(item.variant_id)===id).reduce((n,item)=>n+item.quantity,0);
        form.handleErrorMessage(message+' Your cart contains '+quantity+' of this rug.');
        // Once the server state and visible cart agree, checkout can continue.
        // A stock adjustment alone must not require another cart visit.
        if (form.cart?.renderContents && form.cart?.getSectionsToRender) {
          const sections = form.cart.getSectionsToRender().map(section => section.id);
          const sectionUrl = new URL(cartHref(),location.origin);
          sectionUrl.searchParams.set('sections',sections.join(','));
          const sectionResponse = await fetch(sectionUrl.pathname+sectionUrl.search,{cache:'no-store',signal:AbortSignal.timeout(8000)});
          if (!sectionResponse.ok) throw Error('Cart display unavailable');
          const rendered = await sectionResponse.json();
          if (sections.some(id => typeof rendered[id] !== 'string')) throw Error('Incomplete cart display');
          form.cart.renderContents({...cart,sections:rendered},{open:false});
          form.cart.classList.toggle('is-empty',cart.item_count===0);
          form.cart.querySelector('.drawer__inner')?.classList.toggle('is-empty',cart.item_count===0);
          confirmCart();
        }
      } catch {
        form.handleErrorMessage(message+' Your cart couldn’t be updated. Refresh it before trying again.');
      }
    }
  };
  init(); window.addEventListener('pageshow',init); document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',init);
})();
